import React from "react";
import { AlertCircle } from "lucide-react";
import { Modal } from "../../../../ui/modal/modal.tsx";
import { Button } from "../../../../ui/button/button.tsx";
import styles from "./submit-confirmation-modal.module.css";

interface SubmitConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

export function SubmitConfirmationModal({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: SubmitConfirmationModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Submit Timesheet"
      size="md"
      footer={
        <div className={styles.footer}>
          <Button variant="muted-outline" onClick={onClose} disabled={isSubmitting}>
            Review Again
          </Button>
          <Button onClick={onConfirm} disabled={isSubmitting} variant="accent">
            {isSubmitting ? "Submitting..." : "Yes, Submit"}
          </Button>
        </div>
      }
    >
      <div className={styles.container}>
        <div className={styles.iconWrapper}>
          <AlertCircle size={32} />
        </div>
        <div className={styles.content}>
          <p className="body-md">
            Have you reviewed your entries properly before submitting the timesheet?
          </p>
          <p className={styles.subtext}>
            Once submitted, you won't be able to edit these entries.
          </p>
        </div>
      </div>
    </Modal>
  );
}
